import {
    get as _get,
    isArray as _isArray,
    isFunction as _isFunction,
} from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';

import {Alert} from '@ui';

import {clearMessage, setClosedTimestamp} from '../../../actions/index';
import config from '../../../avcmpConfig';

const ALERT_SEVERITIES = ['error', 'info', 'success', 'warning'];

export class MessageBox extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        messages: PropTypes.object,
        actions: PropTypes.object,
        name: PropTypes.string,
        onClose: PropTypes.func,
    };

    dataForBox = {
        header: '',
        type: '',
        text: '',
    };

    hideTimeoutId = null;

    constructor(props) {
        super(props);

        const messageData = props.messages[props.name];

        if (messageData !== undefined) {
            this.setTimeoutForBox(props);
            this.dataForBox = messageData;
        }

        const isHidden = messageData === undefined;

        this.state = {
            hidden: isHidden,
        };

        this.hideMessageBox = this.hideMessageBox.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.messages !== undefined && this.props.messages[this.props.name] !== undefined) {
            if (prevProps.messages !== this.props.messages || prevProps.name !== this.props.name) {
                this.setState({
                    hidden: false,
                });

                this.dataForBox = this.props.messages[this.props.name];
                this.setTimeoutForBox(this.props);
            }
        } else if (!this.state.hidden) {
            this.setState({hidden: true});
        }
    }

    componentWillUnmount() {
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
            this.hideTimeoutId = null;
        }

        this.hideMessageBox();
    }

    clearHideTimeout = () => {
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
            this.hideTimeoutId = null;
        }
    };

    setTimeoutForBox = (props) => {
        this.clearHideTimeout();

        if (!_get(props, `messages[${props.name}].stayVisible`, false)) {
            this.hideTimeoutId = window.setTimeout(() => {
                this.hideTimeoutId = null;
                this.hideMessageBox();
            }, config.app.notification.timeout);
        }
    };

    hideMessageBox(onDismiss = false) {
        if (this.props.messages[this.props.name] !== undefined) {
            if (_get(this.props, `messages[${this.props.name}].addClosedTimestamp`, false) && onDismiss) {
                this.props.actions.setClosedTimestamp(
                    this.props.name,
                    moment.utc()
                );
            }

            this.props.actions.clear(this.props.name);
            this.setState({hidden: true});

            if (_isFunction(this.props.onClose)) {
                this.props.onClose(this.props);
            }
        }
    }

    dismissMessageBox = () => {
        this.hideMessageBox(true);
    };

    render() {
        const className = this.props.className || '',
            descriptionLines = !_isArray(this.dataForBox.text)
                ? [this.dataForBox.text]
                : this.dataForBox.text;

        const severity = ALERT_SEVERITIES.includes(this.dataForBox.type)
            ? this.dataForBox.type
            : undefined;

        return (
            <div className={`message-box-container ${className} ${this.state.hidden ? '--is-hidden' : ''}`}>
                <Alert
                    icon={false}
                    onClose={this.dismissMessageBox}
                    severity={severity}
                    hidden={this.state.hidden}
                >
                    {this.dataForBox.header && <h4>{this.dataForBox.header}</h4>}
                    {descriptionLines.map((text) => (text ? <p key={text}>{text}</p> : null))}
                </Alert>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        clear: (name) => {
            dispatch(clearMessage({name: name}));
        },
        setClosedTimestamp: (name, timestamp) => {
            dispatch(setClosedTimestamp({name: name, timestamp: timestamp}));
        },
    },
});

const mapStateToProps = (state) => ({
    messages: state.messages,
});

const MessageBoxWithRedux = connect(mapStateToProps, mapDispatchToProps)(MessageBox);

export default MessageBoxWithRedux;
